import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

interface ContextCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  content: string | null;
}

const ContextCheckbox = ({ checked, onChange, label, content }: ContextCheckboxProps) => {
  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={(e) => onChange(e.target.checked)} />}
      label={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body2">{label}</Typography>
          {checked && (
            <Typography variant="caption" color={content ? "success.main" : "text.secondary"}>
              {content ? "Loaded" : "Loading..."}
            </Typography>
          )}
        </Box>
      }
    />
  );
};

export default ContextCheckbox;
